module.exports = __webpack_public_path__ + "static/img/purple-task.888802d0.png";